import { apiFetch } from "../../../shared/api-client";

/**
 * Ask for a password reset link. The server answers the same for an
 * address with no account, so there is nothing to read back.
 */
export async function requestPasswordReset(email: string): Promise<void> {
  await apiFetch<void>("/api/auth/password-reset", {
    method: "POST",
    body: { email },
  });
}

/**
 * Email the signed-in person a link confirming their address, which
 * Firebase asks for before an authenticator app can be added. Sent by
 * HireOS rather than by Firebase, whose own sender did not arrive.
 */
export async function sendVerificationEmail(): Promise<void> {
  await apiFetch<void>("/api/auth/verify-email", { method: "POST" });
}
